type AccountLike = {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
};

// Devuelve la inicial visible del usuario.
export const getAccountInitial = (account?: AccountLike | null): string => {
  const label = [account?.firstName, account?.lastName].filter(Boolean).join(" ") || account?.email || "";

  return label.trim().charAt(0).toUpperCase() || "?";
};
